var _defs, _path, _path2, _polygon, _rect, _polygon2, _polygon3, _polygon4, _rect2, _rect3, _polygon5, _rect4, _polygon6, _rect5, _polygon7, _rect6, _rect7, _rect8, _polygon8, _rect9, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _path3, _polygon12, _rect0, _polygon13, _polygon14, _polygon15, _rect1, _rect10, _polygon16, _rect11, _polygon17, _rect12, _polygon18, _rect13, _rect14, _rect15, _polygon19, _rect16, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _path4, _path5, _path6, _path7, _polygon25, _polygon26, _path8, _path9, _rect17, _polygon27, _polygon28, _polygon29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 394.32 68.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#53b3e1;}.cls-2{fill:#214471;}.cls-3{fill:#c2e1ee;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGINEM-horizontal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.55,39.14c3.09-9.34-3.35-27.45-31.69-24.55,45.92-20,47.49,9.64,31.69,24.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.89,29.16C16.8,38.5,23.24,56.61,51.58,53.71c-45.93,20-47.49-9.63-31.69-24.55"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.32 25.49 14.63 25.49 14.63 25.77 13.35 25.77 13.35 25.09 12.17 25.09 12.17 26.95 12.34 26.95 12.34 27.23 13.51 27.23 13.51 26.95 14.8 26.95 14.8 26.53 16.32 26.53 16.32 25.49"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.11,
    y: 21.69,
    width: 1.17,
    height: 1.17
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.54 21.9 13.37 21.9 13.37 22.79 12.45 22.79 12.45 23.63 13.91 23.63 13.91 23.07 14.54 23.07 14.54 21.9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.83 27.27 10.83 26.29 9.29 26.29 9.29 26.69 9.29 27.27 9.29 27.37 8.28 27.37 8.28 28.35 9.36 28.35 9.36 29.32 10.55 29.32 10.55 28.12 10.15 28.12 10.15 27.27 10.83 27.27"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.08 33.06 8.43 33.06 7.96 33.06 7.83 33.06 7.83 32.19 8.22 32.19 8.22 31.5 7.46 31.5 6.14 31.5 5.13 31.5 5.13 32.69 7.05 32.69 7.05 34.59 7.31 34.59 7.83 34.59 8.43 34.59 8.43 33.94 9.08 33.94 9.08 33.06"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.64,
    y: 32.15,
    width: 1.13,
    height: 1.13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.59,
    y: 35.63,
    width: 1.19,
    height: 1.19
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.52 38.38 6.79 38.38 6.33 38.38 5.6 38.38 5.6 40.2 6.79 40.2 6.79 39.53 7.52 39.53 7.52 38.38"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.97,
    y: 36.73,
    width: 1.81,
    height: 1.81
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.89 43.26 1.89 42.11 0.68 42.11 0.68 43.92 1.43 43.92 1.43 44.79 2.64 44.79 2.64 43.26 1.89 43.26"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.79,
    y: 49.43,
    width: 1.21,
    height: 1.84
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.85 52.3 2.85 51.38 1.64 51.38 1.64 53.22 2.44 53.22 2.85 53.22 3.65 53.22 3.65 52.3 2.85 52.3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.63,
    y: 39.48,
    width: 1.13,
    height: 1.13
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.83,
    y: 45.37,
    width: 1.76,
    height: 1.13
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.32,
    y: 52.13,
    width: 1.59,
    height: 2.16
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.8 46.92 1.55 46.92 1.55 47.69 0 47.69 0 49.85 1.72 49.85 1.72 49.08 2.8 49.08 2.8 46.92"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.66,
    y: 41.22,
    width: 1.2,
    height: 1.63
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.1 54.63 2.1 53.61 0.46 53.61 0.46 55.25 1.68 55.25 1.68 56.1 3.19 56.1 3.19 57.08 4.44 57.08 4.44 56.1 4.44 55.62 4.44 54.63 2.1 54.63"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.21 64.34 11.21 63.34 11.21 62.73 10.11 62.73 10.11 62.71 10.11 62.3 10.11 61.81 8.45 61.81 8.45 62.71 8.92 62.71 8.92 64.74 9.74 64.74 10.06 64.74 10.06 65.35 10.32 65.35 11.21 65.35 12.51 65.35 12.51 64.34 11.21 64.34"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.87 64.26 17.87 62.32 15.45 62.32 15.45 62.98 13.16 62.98 13.16 66.09 13.63 66.09 16.13 66.09 16.6 66.09 16.6 65.28 16.13 65.28 16.13 64.26 17.87 64.26"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.38 65.78 19.39 65.78 18.81 65.78 17.74 65.78 17.74 66.62 15.94 66.62 15.94 67.84 19.39 67.84 19.39 67.25 19.39 67.09 21.38 67.09 21.38 65.78"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.78 59.3 9.78 59.08 9.78 58.76 9.78 58.2 8.52 58.2 8.52 58.85 7.62 58.85 7.62 57.94 6.78 57.94 6.78 57.12 5.2 57.12 5.2 58.37 6.07 58.37 6.07 58.88 3.58 58.88 3.58 60.13 4.77 60.13 4.77 61.07 7.62 61.07 7.62 60.13 7.62 59.82 7.62 59.73 8.89 59.73 8.89 60.2 9.5 60.2 9.78 60.2 10.7 60.2 10.7 59.3 9.78 59.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.37,52l-10.89.52,2.74,2.32h0a67.56,67.56,0,0,1-12.45,6c-7.58,2.7-14.22,4.06-19.83,4.06h-.73a27.16,27.16,0,0,1-3.52-.28l0,.89h1.21v1.73H21.76l0,1.23a32.83,32.83,0,0,0,3.72.27h.81a62.73,62.73,0,0,0,19.05-3.26,87.09,87.09,0,0,0,13.91-5.88l2.81-1.47,2.53,2.13Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "73.7 43.19 75.39 43.19 75.39 42.91 76.68 42.91 76.68 43.59 77.85 43.59 77.85 41.73 77.69 41.73 77.69 41.45 76.52 41.45 76.52 41.73 75.22 41.73 75.22 42.15 73.7 42.15 73.7 43.19"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.74,
    y: 45.82,
    width: 1.17,
    height: 1.17
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.48 46.78 76.66 46.78 76.66 45.89 77.58 45.89 77.58 45.05 76.12 45.05 76.12 45.61 75.48 45.61 75.48 46.78"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.19 41.42 79.19 42.4 80.74 42.4 80.74 42 80.74 41.42 80.74 41.32 81.75 41.32 81.75 40.34 80.67 40.34 80.67 39.37 79.47 39.37 79.47 40.57 79.88 40.57 79.88 41.42 79.19 41.42"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.95 35.62 81.59 35.62 82.06 35.62 82.19 35.62 82.19 36.49 81.8 36.49 81.8 37.19 82.56 37.19 83.88 37.19 84.89 37.19 84.89 35.99 82.97 35.99 82.97 34.09 82.71 34.09 82.19 34.09 81.59 34.09 81.59 34.74 80.95 34.74 80.95 35.62"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 79.26,
    y: 35.4,
    width: 1.13,
    height: 1.13
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 84.25,
    y: 31.87,
    width: 1.19,
    height: 1.19
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.51 30.31 83.23 30.31 83.7 30.31 84.42 30.31 84.42 28.48 83.23 28.48 83.23 29.15 82.51 29.15 82.51 30.31"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.24,
    y: 30.14,
    width: 1.81,
    height: 1.81
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "88.13 25.43 88.13 26.58 89.34 26.58 89.34 24.76 88.59 24.76 88.59 23.89 87.38 23.89 87.38 25.43 88.13 25.43"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.02,
    y: 17.41,
    width: 1.21,
    height: 1.84
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.17 16.38 87.17 17.31 88.38 17.31 88.38 15.46 87.58 15.46 87.17 15.46 86.37 15.46 86.37 16.38 87.17 16.38"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.26,
    y: 28.07,
    width: 1.13,
    height: 1.13
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 84.44,
    y: 22.18,
    width: 1.76,
    height: 1.13
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 84.12,
    y: 14.39,
    width: 1.59,
    height: 2.16
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.23 21.77 88.48 21.77 88.48 20.99 90.03 20.99 90.03 18.83 88.31 18.83 88.31 19.6 87.23 19.6 87.23 21.77"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.16,
    y: 25.84,
    width: 1.2,
    height: 1.63
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.92 14.05 87.92 15.08 89.56 15.08 89.56 13.43 88.34 13.43 88.34 12.59 86.84 12.59 86.84 11.6 85.59 11.6 85.59 12.59 85.59 13.06 85.59 14.05 87.92 14.05"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.81 4.35 78.81 5.34 78.81 5.95 79.91 5.95 79.91 5.97 79.91 6.38 79.91 6.88 81.58 6.88 81.58 5.97 81.1 5.97 81.1 3.94 80.28 3.94 79.96 3.94 79.96 3.33 79.71 3.33 78.81 3.33 77.52 3.33 77.52 4.35 78.81 4.35"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.16 4.43 72.16 6.36 74.58 6.36 74.58 5.71 76.87 5.71 76.87 2.59 76.4 2.59 73.89 2.59 73.42 2.59 73.42 3.4 73.89 3.4 73.89 4.43 72.16 4.43"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.64 2.91 70.63 2.91 71.21 2.91 72.28 2.91 72.28 2.06 74.08 2.06 74.08 0.85 70.63 0.85 70.63 1.43 70.63 1.59 68.64 1.59 68.64 2.91"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.25 9.39 80.25 9.61 80.25 9.92 80.25 10.49 81.51 10.49 81.51 9.83 82.4 9.83 82.4 10.74 83.25 10.74 83.25 11.56 84.83 11.56 84.83 10.31 83.95 10.31 83.95 9.8 86.44 9.8 86.44 8.55 85.26 8.55 85.26 7.61 82.4 7.61 82.4 8.55 82.4 8.86 82.4 8.95 81.13 8.95 81.13 8.48 80.52 8.48 80.25 8.48 79.33 8.48 79.33 9.39 80.25 9.39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.66,16.72l10.89-.52L31.8,13.89h0a67,67,0,0,1,12.45-6c7.58-2.69,14.23-4.06,19.83-4.06h.73a31.22,31.22,0,0,1,3.52.28l0-.88H67.1V1.51h1.16l0-1.22A33.11,33.11,0,0,0,64.51,0h-.82a62.4,62.4,0,0,0-19,3.27A87.68,87.68,0,0,0,30.73,9.14l-2.81,1.47L25.4,8.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.38,50.92l.11-.06.18-.66s.14-.56.36-.65,1.5-.52,1.5-.52c.42-.56-.07-.77-.07-.77a.37.37,0,0,1-.45-.17c-.19-.28.19-.37.45-.66a.57.57,0,0,0,.07-.63l.35-.33s-.63.12-.56,0a2.18,2.18,0,0,0,.16-.33,9.11,9.11,0,0,1-3.07.51,11.81,11.81,0,0,1-1.58-.23c-.11-.09-.49.14-.75.19a.61.61,0,0,1-.58-.31c-.14-.19.09-.37.09-.37l-.28.16a3.39,3.39,0,0,1-.68-.16,5.34,5.34,0,0,0-1.06,0l-.73.11a1.82,1.82,0,0,1-.32-.28c-.1-.12-.66-.35-.8-.47-.31-.61-.52-.42-.52-.42a4.45,4.45,0,0,1-2-.07c-.61-.59-1.39-.59-1.81-.82s-1.55.61-1.55.61a8.64,8.64,0,0,1-1.08.51,3.41,3.41,0,0,1-.87-.32l-.33-.36-.28-.28a5.71,5.71,0,0,1-.42-.54,4.55,4.55,0,0,0-.42-.49l-.14-.33a2.16,2.16,0,0,1-.4,0,2.46,2.46,0,0,1-.64-.21,4.24,4.24,0,0,0-.07-.71l-.63-.35s0-.21,0-.28.43.4.43.4l.3,0s.87-.07,1-.07a4.05,4.05,0,0,1,.87.45s.14.14.28.26.82,0,.82,0l.66.33.1.21.61.28s.07,0,.58,0,.61,0,.66-.31-.59-.26-.59-.26l-.61-.09L31.82,42l-.21-.24-.45.07-.68-.44c-.33-.29-1.13,0-1.13,0l-.56,0s-.49.09-.61.09a2,2,0,0,1-.49-.21l-.22-.19-.3-.07-.56-.47-.12-.23-.42-.12a1.5,1.5,0,0,1-.21-.35c-.07-.19.25-.47.25-.47.08-.45,1.83-.31,2.14-.28s.16.47.28.7a1.12,1.12,0,0,0,.66.42c.16,0,.49-.21.49-.21l-.44-.09s-.5-.17-.54-.5-.05-.3.42-.32.63-.59.63-.59c-.16-.59.59-.59.59-.75a2.47,2.47,0,0,1,.35-.68l.4-.59a.77.77,0,0,0,.92-.54c0-.09.61-.3.61-.3s.32.32.56.06a.32.32,0,0,0,0-.46,1.06,1.06,0,0,1-1-.54c-.25-.29.57-.87.73-.85s1.2-.12,1.22,0,.4.4.4.4.12-.07.16.21.73.12.73.12l.26-.33-.42-.33a1.34,1.34,0,0,0-.33-.52.87.87,0,0,1-.75-.21l-.07-.33-.52-.19s-.21,0-.14-.14,0-.54-.07-.54l-.61.05-.16-.12c-.31.07-1-.32-1-.32l0-.15a2.65,2.65,0,0,0,.42-1.12,5.52,5.52,0,0,1,.47-.45,6.43,6.43,0,0,0,.59-.59L33,29c.51.18.61-.21.61-.21l-.42-.33a15.13,15.13,0,0,1-1.39-.82c-.28-.24-.09-.66-.09-.66l.58-.57a3.11,3.11,0,0,1,.45-.3l.47.56a.36.36,0,0,0,.44.07,1.5,1.5,0,0,1,1.23.78,2.25,2.25,0,0,1,0,1.29l.42.73.19,0,.44.66.47-.16.31,0a.36.36,0,0,0,.3.45.31.31,0,0,0,.42-.28s-.18-.26,0-.45,0-.52,0-.52l-.19-.46s.12-.38.24-.38.35-.24.35-.24l.35-.23,0-.38c.93.64.56-.44.56-.44l.87-.1.3-.49-.35-.68a1,1,0,0,1-.35-.23,3.9,3.9,0,0,1-.38-1.13l-.35-.21-.4.28-.33,0,0,.1-.23,0L37,24.48l-.46.4s-1.37.63-1.84.91-1.8-.54-1.8-.54a1.17,1.17,0,0,0-.89-.18.56.56,0,0,0-.36.77.45.45,0,0,1-.16.47s-.07.23-.45.23-.26.4-.26.4l.08.57-.38.35-.12.33a8.6,8.6,0,0,1-1,.3,3.7,3.7,0,0,1-.82,0,.77.77,0,0,0-.51-.19c-.29,0-.31-.19-.31-.19a1.1,1.1,0,0,0-.09-.46c-.12-.31.47-.62.68-.57s.49-.23.37-.59.33-.28.33-.28l.31-.23-.73-.31a3.43,3.43,0,0,1-1,.59c-.38.09-.26-.31-.4-.47s.09-.47.09-.47l.71-.61-.13-.1c0-.39,1.4-1.59,1.4-1.59a2.89,2.89,0,0,0-2.07,1c-3.56,4.35-5.08,9.83-3.61,15.07,0,0,1,4.41,7.2,6,0,0,.63.36.94.26a2.43,2.43,0,0,0,.63.17c.38,0,.31.47.49.65s.05.61.05.61.12.54.4.59a.37.37,0,0,1,.3.33l.36.14a1.24,1.24,0,0,0,.44.4c.24.09.87.26.87.26s.45,0,.45.16.63.33.7.33l.47,0s.92.16,1,.35a1,1,0,0,0,.4.33l1.45.42a2.81,2.81,0,0,0,.36.19,4.7,4.7,0,0,0,1.19.26,1.64,1.64,0,0,0,1.18.3s.82.54,1.12.47a1.13,1.13,0,0,1,.8.12c.24.12.68-.12.68-.12l.78,0s.4-.36.5-.29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.52,29.91c-2.67-9.59-13.91-14.83-25.1-11.71a5.4,5.4,0,0,0,1.35.29l-.33.24A23,23,0,0,0,44,18.4l1,.28.7.38,1.69.19a2.89,2.89,0,0,0,1.32,2.91l-3.15.37,0,.75.15.38a.87.87,0,0,1,.79.84,5,5,0,0,1,0,.9l.09.42,1.74.28s0-.19.33-.28.37-1,.09-1.27a2.17,2.17,0,0,0-.8-.33l-.28-.47.66-.37,1.36.56s1.55.56.42,2.21l-.8.47-.14.61-.19,1-.56.38s-1.08-.43-1.17-.71-.85-.18-.85-.18l.19.23s1.27.42,1.13,1.22l-.47.14-.21,0-.68.08.23.23.61-.14.8-.14s2.16-.05,1.88.84-.75,1-.75,1-.47.33-.24.7a1.91,1.91,0,0,0,1.41.75s0-.61.7-.52l-.14.33.61.33a1.49,1.49,0,0,0-.28.71c0,.32.19.79-.23,1.22l.28.61s-1,.23-.85.84l.14.61-.28.66a2.43,2.43,0,0,1,.66,1.31l1,.29-.14.32.66.19.38.33.33-.37,1,.09.33.47.94.19.19-.47.75-.43.65.33.85-.89,1.08-.33.14-.7.61-.33.84.37s.15-.93.61-.84.8-.05.8,1.5l1.51.14.37.9.38.09-.14,1-.38.57.47.51-.19.38a1.85,1.85,0,0,0,1.88-.56s2.06-3-.19-11.59m-6.76-2-.94.56v.57a7.89,7.89,0,0,1-1.36.61c-.14-.05-.84.61-.84.61l-1.13-.43-.33.61-.47.29c-.23-.19-.28.37-.28.37l-1,.47-.84-.28s-.14-.28-.47-1,.7-1.32.7-1.32l.47-.42c.61-.28.19-.47.19-.47.28-.84,1-.56,1.46-.56a4.63,4.63,0,0,0,1.17-.24l.42-.8,1.27.05.33-.37L58.43,26l.52.89Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41,27.84l1.13-.33-.1.28s.38.14,0,.33-.51.28-1-.28"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "42.38 21.83 41.72 22.39 42.75 22.58 43.18 21.97 42.28 22.25 42.38 21.83"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "110.97 19.64 116.89 19.64 116.89 48.69 135.54 48.69 135.54 53.04 110.97 53.04 110.97 19.64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.59,19.16q9.6,0,16,4.9T188,36.35q0,7.4-6.44,12.24t-16.24,4.84q-9.36,0-15.6-4.84t-6.23-12.14a15.09,15.09,0,0,1,6.28-12.39q6.27-4.89,15.87-4.9m.24,4.55q-7.11,0-11.68,3.58a11.16,11.16,0,0,0-4.58,9.16,11,11,0,0,0,4.59,9,20.15,20.15,0,0,0,23.06-.07,11.21,11.21,0,0,0,4.63-9.11,11,11,0,0,0-4.63-8.93,17.93,17.93,0,0,0-11.39-3.62"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.17,36.59h13.9V50.75a45.76,45.76,0,0,1-15.17,2.68q-10.29,0-16.44-4.85t-6.15-11.94q0-7.49,6.38-12.46t16-5a34.59,34.59,0,0,1,6.64.61,63.49,63.49,0,0,1,7.94,2.24v4.87a34.47,34.47,0,0,0-14.7-3.46A17.7,17.7,0,0,0,209.1,27.2a11.49,11.49,0,0,0,0,18.46q4.65,3.6,12,3.61a33.78,33.78,0,0,0,8.5-1.32l.57-.14v-7h-8Z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 249.34,
    y: 19.64,
    width: 5.93,
    height: 33.4
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "301.9 19.64 307.53 19.64 307.53 53.04 302.44 53.04 274.75 27.32 274.75 53.04 269.18 53.04 269.18 19.64 273.99 19.64 301.9 45.58 301.9 19.64"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "320.95 19.64 344.42 19.64 344.42 23.9 326.88 23.9 326.88 34.08 343.83 34.08 343.83 38.36 326.88 38.36 326.88 48.74 344.98 48.74 344.98 52.99 320.95 52.99 320.95 19.64"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "388.78 19.64 394.32 19.64 394.32 53.04 388.36 53.04 388.36 27.05 375.63 39.97 374.54 39.97 361.66 27.05 361.66 53.04 355.73 53.04 355.73 19.64 361.34 19.64 375.1 33.36 388.78 19.64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHo);
export default __webpack_public_path__ + "static/media/logoHo.fe787dba0e5717e33e1435b56673191a.svg";
export { ForwardRef as ReactComponent };